<template>
  <b-form-group
    :label="$t('users.form.userType')"
    label-for="id_user_types"
  >
    <validation-provider
      #default="{ errors }"
      :name="$t('users.form.userType')"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_user_types"
        :options="userTypes"
        label="title"
        :reduce="type => type.id"
        :placeholder="$t('users.form.userType')"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'UserType',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['users/dataItem']
    },
    userTypes() {
      return this.$store.getters['userTypes/dataList']
    },
  },
  created() {
    this.getUserTypes()
  },
  methods: {
    getUserTypes() {
      this.$store.dispatch('userTypes/getDataList', {
        select: [
          'user_types.id AS id',
          'user_types.title AS title',
        ],
      })
    },
  },
}
</script>
